import AsControl from '../AsControl';
import bindControlToForm from '../../utils/hoc/formHelpers/bindControlToForm';
import { MenuSelection as PureMenuSelection } from './MenuSelection';

export const MenuSelection = AsControl()(PureMenuSelection);
export const MenuSelectionControl = bindControlToForm()(MenuSelection);
